import React from 'react';
import { Description, Hint, RefreshButton, Wrapper } from './styles/NoAvailableGamesStyles';

interface IProps {
  button: JSX.Element;
  organizationName?: string;
}

const NoAvailableGames: React.FC<IProps> = (props) => {
  const { button } = props;

  return (
    <Wrapper>
      <Description>No games are currently available.</Description>
      <Hint>If the games you want to access are shared, make sure the 'Shared Network' option is enabled.</Hint>
      <RefreshButton>{button}</RefreshButton>
    </Wrapper>
  );
};

export default NoAvailableGames;
